export default class navigation {
  constructor(paramters) {
    this.navigation = document.querySelector('.c-jump-mark-navigation');
    this.navigationToggle = this.navigation.querySelector('.c-jump-mark-navigation__toggle');

    this.navigationToggle.addEventListener('click', this.toggleNavigation);
    this.createNavigation(paramters.idPrefix);
  }

  toggleNavigation() {
    this.parentNode.classList.toggle('c-jump-mark-navigation--is-open');
  }

  createNavigation(prefix) {
    const jumpMarks = document.querySelectorAll('[id*=' + prefix + ']');

    if(jumpMarks.length) {
      this.navigation.classList.add('c-jump-mark-navigation--has-navigation');

      jumpMarks.forEach((element) => {
        this.createNavigationItem(element)
      });
    }
  }

  createNavigationItem(element) {
    const title = element.querySelector('.u-overline');
    const navigationLinks = this.navigation.querySelector('.c-jump-mark-navigation__links');

    // Create new navigation item
    let navigationItem = document.createElement('a');
    navigationItem.innerHTML = title.innerHTML;
    navigationItem.classList.add('o-btn', 'o-btn--icon', 'o-btn--link', 'c-jump-mark-navigation__link');
    navigationItem.href = '#' + element.id;

    // Append item to navigation
    navigationLinks.appendChild(navigationItem);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/jump-mark-navigation.js